import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { isComparisonUnchanged } from '../fplusDiff/diffModel'
import { DiffEntry } from './DiffEntry'

type Props = {
  current: Optional<string>
  compare: Optional<string>
}

/**
 * A parent reference is a single identifier, where a diff would add noise rather
 * than information, so it keeps the before-beside-after presentation.
 */
export const SubTemplateFieldValueParentIdDiff = ({
  current,
  compare,
}: Props) => {
  const translate = useTranslate()

  if (isComparisonUnchanged(compare, current)) {
    return null
  }

  return (
    <DiffEntry
      title={translate('diffPopover.field.parentId')}
      compare={compare}
      current={current}
    />
  )
}
